/*
Akhila 11/19/2022 2700271704 Created new Component
Sohel 11/21/2022 2700271704 Integrated save API and populate values
Akhila 11/23/2022 2700271704 disable save button if data is empty
Sohel 11/23/2022 2700271704 Added Alert Popup
Akhila 11/25/2022 2700271704 validation message, textField label name, placeholder change
akhila 11/26/2022 2700271704 changed label for code and description
Lalitha 30/11/2022 2700271704   Added validation on code
Suresh peddavoora 11/30/2022 2700271704 Button Spacing Alignment Issue Fixed.
Sohel 12/04/2022 2700271704 Account Update Group validation and payload Changes
Sohel 07/12/2022  2700271704 Trigger validation after touched field
Lalitha 12/09/2022 2700271704  Added reusable backButtonText
Rajesh 12/15/2022 2700271704 added role access
dilip 01/02/2022 2700271704 fixed code lowercase issue
sai krishna  1/2/2023 2700271704 renamed textfield labels
Akhila 01/25/2023 2700271704 validation issue fixed
Ravi 02/20/2023 2700271704 fixed validation issue in code
Raghu 02/23/2023 2700271704 fixed new Ui changes
sohel 03/06/2023 2700271704 Added validation message for existing value
Akhila 05/31/2023 2700271704 unsaved changes bug fixed
Akhila 06/14/2023 2700271704 bug fix unsaved changes on save button
Akhila 06/21/2023 2700271704 conditionally disable save and finish button on submission
Bhuvan 12/11/2023 2700271704 changed validation changes for account update code and account update description
*/
import React, {useContext, useState} from 'react';
import {useForm} from 'react-hook-form';
import {TextField, FormControl, Button, MenuItem} from '@material-ui/core';
import {Controller} from 'react-hook-form';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {useSelector, useDispatch} from 'react-redux';
import PageLoader from './../../../../components/PageLoader/index';
import {ErrorSnackbar} from './../../../../components/CustomSnackBar/index';
import {SuccessSnackbar} from './../../../../components/CustomSnackBar/index';
import {useEffect} from 'react';
import {FormHelperText} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';
import AddClientAccountTable from './AddClientAccount/AddClientAccountTable';
import {fetchAllGroupCode} from '../../../../redux/reducers/AccountUpdateGroup/index';
import {
  postAccountUpdateGroup,
  resetMessage,
} from '../../../../redux/reducers/AccountUpdateGroup/index';
import SelectTabContextProvider from '../../../../components/SelectTabContext/SelectTabContext';
import {backButtonText} from '../../../../util/Content';
import {setAlertData} from '../../../../redux/reducers/UnsavedChangesAlertReducer';
import {submissionStart} from '../../../../redux/reducers/CommonActions/commonActions';

export default function AddTriggerAccount({
  setTabValue,
  handleTabChange,
  handleDirty,
  showAlertRef,
}) {
  const [clientFormData, setClientFormData] = useState([]);
  const [deletedClientData, setDeletedClientData] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [codePopover, setCodePopover] = useState(false);
  const [triggerCodesData, setTriggerCodesData] = useState();
  const [triggersData, setTriggersData] = useState([]);
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {
    loading,
    successMsg,
    errorMsg,
    addAccountUpdateGroupStatus,
    accountUpdateGroupData,
    allGroupCode,
  } = useSelector(({accountUpdateGroup}) => accountUpdateGroup);
  const {roleData} = useSelector(({role}) => role);
  const disable = roleData?.window?.['Account Update']?.['AUG'];
  const initialValues = {
    groupCode: accountUpdateGroupData?.groupCode ? accountUpdateGroupData?.groupCode : '',
    description:
      accountUpdateGroupData && accountUpdateGroupData?.groupDescription ?
        accountUpdateGroupData?.groupDescription :
        '',
  };
  const {setSaveTab} =
    useContext(SelectTabContextProvider);
  const checkGroupCodeExist = (value) => {
    if (allGroupCode && allGroupCode?.length > 0 && value) {
      const ar = [];
      allGroupCode.filter((i) => {
        if (
          i?.groupCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkGroupCodeAlreadyExist = (value) => {
    if (allGroupCode && allGroupCode?.length > 0 && value) {
      const ar = [];
      allGroupCode.filter((i) => {
        if (
          i?.groupCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const getTriggerCodesData = () => {
    if (allGroupCode && allGroupCode?.length > 0) {
      return allGroupCode?.filter(
        (i) => String(i?.groupCode?.toUpperCase())?.startsWith(triggerCodesData?.toUpperCase()) && i?.isActive === 'Y',
      );
    } else {
      return [];
    }
  };

  useEffect(() => {
    reset(initialValues);
    if (accountUpdateGroupData?.triggerFields?.length > 0) {
      const triggerGroupClientData = accountUpdateGroupData?.triggerFields?.map((item) => {
        return {
          ...item,
          formulaCode: item?.formulaCode || '',
          fieldCode: item?.repositoryName || '',
          tableData: item?.triggerAccountUpdateFieldsId,
          value: item?.fieldValue || '',
          description: item?.fieldCode || '',
          fieldType: item?.fieldType || '',
        };
      });
      setTriggersData(triggerGroupClientData);
      setClientFormData(triggerGroupClientData);
    }
  }, [accountUpdateGroupData]);

  const validationSchema = Yup.object().shape({
    groupCode: accountUpdateGroupData?.groupCode ?
      null :
      Yup.string()
        .required('Account Update Name is required')
        .test(
          'groupCode',
          'Account Update Name already exist',
          (value) => !checkGroupCodeExist(value),
        )
        .test(
          'groupCode',
          'Account Update Name has already been used in the past',
          (value) => !checkGroupCodeAlreadyExist(value),
        ),

    description: Yup.string()
      .test('description', 'Account Update Description is required', (value) => {
        return value?.replaceAll(' ', '');
      })
      .required('Account Update Description is required'),
  });

  const {
    handleSubmit,
    control,
    reset,
    errors,
    setValue,
    getValues,
  } = useForm({
    mode: 'all',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2000);
    }
    if (errorMsg) {
      setDisabled(false);
    }
  }, [successMsg, errorMsg]);

  useEffect(() => {
    if (addAccountUpdateGroupStatus === 200) {
      setTimeout(() => {
        setTabValue(0);
      }, 2000);
    }
  }, [addAccountUpdateGroupStatus, successMsg]);

  useEffect(() => {
    dispatch(fetchAllGroupCode());
    setSaveTab(false);
  }, []);

  const onSubmit = (data) => {
    setDisabled(true);
    if (data) {
      dispatch(submissionStart());
      const triggerFields =
        clientFormData?.length > 0 ?
          clientFormData?.map((item) => {
            return {
              repositoryName: item?.fieldCode || '',
              fieldValue: item?.value || '',
              formulaCode: item?.formulaCode || '',
              formulaRuleGroupId:item?.formulaRuleGroupId ? item?.formulaRuleGroupId : "",
              fieldId:item?.fieldId ? item?.fieldId : "",
              dataRepositoryId:item?.dataRepositoryId ? item?.dataRepositoryId : "",
              groupCode: data?.groupCode ? data?.groupCode : '',
              triggerAccountUpdateFieldsId: item?.triggerAccountUpdateFieldsId ?
                item?.triggerAccountUpdateFieldsId :
                0,
              fieldCode: item?.description || '',
              fieldType: item?.fieldType || '',
              fieldDescription: '',
            };
          }) :
          [];

      const passValues = {
        deletedTriggerFields: deletedClientData?.length > 0 ? deletedClientData : [],
        groupCode: data?.groupCode ? data?.groupCode : '',
        groupDescription: data?.description ? data?.description : '',
        triggerAccountUpdateGroupId: accountUpdateGroupData?.triggerAccountUpdateGroupId ?
          accountUpdateGroupData?.triggerAccountUpdateGroupId :
          0,
        triggerFields: triggerFields,
      };
      dispatch(postAccountUpdateGroup(passValues));
    }
    handleDirty(false, 'fixed');
  };
  window.onclick = function() {
    setCodePopover(false);
  };
  return (
    <>
      <div className={`mb-0`}>
        <div className="new-standard-textfields button-table-spacing-mb justify-content-start">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn`}
            onClick={() => {
              if (showAlertRef.current) {
                // handleTabChange("e", 0);
                dispatch(
                  setAlertData({
                    showAlert: showAlertRef.current,
                    alertCallback: () => {
                      setTabValue(0);
                    },
                  }),
                );
              } else {
                setTabValue(0);
              }
            }}
          >
            <ArrowBack className="mr-2" />
            {backButtonText}
          </Button>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="form-row align-items-center global-field-textfields new-standard-textfields">
            <div className="col-sm-6 col-md-4 col-lg-4 form-group">
              {/* <div className={`col-sm-6 col-md-4 col-xl-3 ${errors?.groupCode?.message ? 'form-group-lg' : 'form-group'}`}> */}
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({value, onChange, onBlur}) => (
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Account Update Name"
                      margin="dense"
                      name="groupCode"
                      variant="outlined"
                      label="Account Update Name"
                      value={value}
                      onBlur={onBlur}
                      inputProps={{maxLength: 25}}
                      disabled={Boolean(accountUpdateGroupData?.groupCode)}
                      onChange={(e) => {
                        handleDirty(true);
                        setValue('groupCode', e.target.value);
                        if (e.target.value) {
                          setCodePopover(true);
                          setTriggerCodesData(e.target.value);
                        } else if (e.target.value === '') {
                          setCodePopover(false);
                        }
                      }}
                      error={Boolean(errors.groupCode?.message)}
                      required
                      autoComplete='off'
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      fullWidth
                    />
                  )}
                  control={control}
                  name="groupCode"
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.groupCode?.message ? errors.groupCode.message : ''}
              </FormHelperText>
              <div className="windowcode-popover Add-trigger-group-popover">
                {codePopover &&
                  getTriggerCodesData()?.map((data, i) => (
                    <MenuItem key={i}>
                      {data?.groupCode?.replace(/ /g, '\u00a0')}
                    </MenuItem>
                  ))}
              </div>
            </div>
            {/* </div> */}

            <div className="col-sm-6 col-md-4 col-lg-4 form-group">
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({value, onChange, onBlur}) => (
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Account Update Description"
                      margin="dense"
                      name="description"
                      variant="outlined"
                      label="Account Update Description"
                      value={value}
                      onBlur={onBlur}
                      inputProps={{maxLength: 100}}
                      // onChange={onChange}
                      onChange={(e) => {
                        handleDirty(true);
                        setValue('description', e.target.value);
                      }}
                      error={Boolean(errors?.description?.message)}
                      required
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      fullWidth
                    />
                  )}
                  control={control}
                  name="description"
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.description?.message ? errors.description.message : ''}
              </FormHelperText>
            </div>
          </div>
          <div className={`border-rounded`}>
            <AddClientAccountTable
              clientFormData={clientFormData}
              setClientFormData={setClientFormData}
              setDeletedClientData={setDeletedClientData}
              deletedClientData={deletedClientData}
              getValues={getValues}
              handleDirty={handleDirty}
            />
          </div>
          <div className="row justify-content-center mt-4 mb-2 new-standard-textfields">
            <Button
              type="button"
              onClick={() => {
                reset(initialValues);

                setClientFormData(triggersData?.length > 0 ? triggersData : []);
              }}
              variant="outlined"
              className={`reset-btn mx-1 ${classes.buttonRoot}`}
              disabled={accountUpdateGroupData?.groupCode && !disable?.edit}
            >
              Reset
            </Button>
            <Button
              type="submit"
              variant="outlined"
              className={`search-btn mx-1 ${classes.buttonRoot}`}
              disabled={
                disabled ||
                clientFormData?.length === 0 ||
                (accountUpdateGroupData?.groupCode && !disable?.edit) ||
                enabledSubmission
              }
            >
              Save
            </Button>
          </div>
          {/* {setSample(isDirty)} */}
        </form>
      </div>
      {loading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
}
